import { render } from "./BannerTwo.vue?vue&type=template&id=86443a1e"
import script from "./BannerTwo.vue?vue&type=script&lang=js"
export * from "./BannerTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__